import {
  CSW_ARROW_CLICK,
  CSW_PRODUCT_CLICK,
  CSW_SHOW_ALL_CLICK,
  SELLER_MODAL_XSELL,
} from 'shared/experiments/consts'
import { event as e } from 'shared/experiments/utils/event'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'

export default () => {
  const experiment = getExperimentOnClient(SELLER_MODAL_XSELL)
  const modalContainer = document.getElementById('seller-modal')

  if (!experiment.isEnabled) {
    return
  }

  // if modal button clicked, activate the experiment
  const openModalButton = document.querySelector(
    '[data-clientside-hook*="open-seller-modal"]'
  )

  openModalButton?.addEventListener('click', async () => {
    await activateExperiment(SELLER_MODAL_XSELL)
  })

  modalContainer?.addEventListener('click', event => {
    const target = event.target as HTMLElement

    if (target.closest('[data-clientside-hook~="slider__item"]')) {
      trackEvent(CSW_PRODUCT_CLICK)
    }
    if (
      target.closest('.m-Modal__close-text') ||
      target.closest('.m-Modal__close')
    ) {
      trackEvent(e`Modal Closed`)
    }
    if (target.closest('[data-clientside-hook~="adaptable__arrows"]')) {
      trackEvent(CSW_ARROW_CLICK)
    }
    if (target.closest('[data-clientside-hook~="slider__header"] a')) {
      trackEvent(CSW_SHOW_ALL_CLICK)
    }
  })
}
